import createReReSelector from 're-reselect';
import { createSelector } from 'reselect';

import { experimentsEditorInitialState } from '../../reducers/experimentsEditor';
import { getCampaignValue } from '../../selectors/campaignsEdit/campaignsEdit';
import { getCampaignExperimentsEditorId } from '../../service/CampaignsEditHelpers/CampaignsEditHelpers';
import {
    EditCampaignDataValue,
    EditCampaignValueField
} from '../../typings/campaignsEdit';
import { ConstData, ConstExperimentsData } from '../../typings/constants';
import {
    ExperimentsEditorData,
    ExperimentsEditorState,
    ExperimentsValue
} from '../../typings/experimentsEditor';
import { State } from '../../typings/state';

export const selectExperimentsEditorById = (
    experimentsEditor: ExperimentsEditorState,
    editorId: string
): ExperimentsEditorData => {
    const experimentsEditorId = getCampaignExperimentsEditorId(editorId);
    return (
        experimentsEditor[experimentsEditorId] || experimentsEditorInitialState
    );
};

export const selectSavedExperiments = createReReSelector(
    getCampaignValue,
    (campaignValue: EditCampaignDataValue): ExperimentsValue => {
        return campaignValue[EditCampaignValueField.experiments];
    }
)((state: State, editorId: string) => editorId);

export const selectExperimentsConstants = createSelector(
    (state: State) => state.commonData.constants,
    (constants: ConstData): ConstExperimentsData => {
        if (constants === undefined) {
            throw Error('No constants data');
        }

        return { ...constants.experimentsConstants };
    }
);
